import { getSoundCloudClientId, startClientIdAutoRefresh } from "./clientIdManager";

let initialized = false;

export function initSoundCloudClientIdLifecycle() {
  if (initialized) return;
  initialized = true;

  // Warm up client_id once at app start.
  getSoundCloudClientId().catch(() => {
    // Silent fail; next API calls can retry.
  });

  // Re-fetch exactly every cache interval (5h by config).
  startClientIdAutoRefresh();
}
